import React from 'react';
import Us1_ele_sub from './us1_ele_sub';

const Us1_ele = () => {
  return (
    <div>
      <Us1_ele_sub />
    </div>
  );
}

export default Us1_ele;
